export interface UserActionEntry {
  action: string;
  role?: string;
  userId?: string;
  route?: string;
  entityId?: string;
  timestamp: string;
  meta?: Record<string, unknown>;
}

const actionLog: UserActionEntry[] = [];
const MAX_LOG = 500;

export function logUserAction(
  entry: Omit<UserActionEntry, 'timestamp'> & { timestamp?: string }
): void {
  const full: UserActionEntry = {
    ...entry,
    timestamp: entry.timestamp ?? new Date().toISOString(),
  };

  actionLog.push(full);
  if (actionLog.length > MAX_LOG) actionLog.shift();

  if (import.meta.env.DEV) {
    console.info(`[UserAction] ${full.action}`, full);
  }
}

export function getUserActionLog(): ReadonlyArray<UserActionEntry> {
  return actionLog;
}

export function clearUserActionLog(): void {
  actionLog.length = 0;
}
